const Google = () => {
    return (
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
        >
            <path
                d="M20.417 2H17V7H22V3.40989C22 3.40989 21.7529 2.13636 20.417 2Z"
                fill="#1967D2"
            />
            <path d="M17 21.9769V21.9891V22L22 17H21.9551L17 21.9769Z" fill="#1967D2" />
            <path d="M22 7H17V17H22V7Z" fill="#FBBC05" />
            <path d="M22 17H17V22L22 17Z" fill="#EA4335" />
            <path d="M7 17V22H16.989L17 17H7Z" fill="#34A853" />
            <path d="M2 17V20.4764C2.04584 21.6045 3.29026 22 3.29026 22H7V17H2Z" fill="#188038" />
            <path
                d="M6.57632 6.63506H17V2H3.31314C3.31314 2 2.08389 2.1264 2 3.43211V17H6.57632V6.63506Z"
                fill="#4285F4"
            />
            <path
                d="M10.0248 15C9.79341 15 9.57025 14.9692 9.35539 14.9078C9.14598 14.8464 8.95319 14.7542 8.77691 14.6312C8.60054 14.5027 8.44355 14.3436 8.30576 14.1536C8.1736 13.9637 8.07162 13.743 8 13.4916L9.0165 13.081C9.08811 13.3603 9.20939 13.5726 9.38012 13.7179C9.55096 13.8575 9.76581 13.9274 10.0248 13.9274C10.1405 13.9274 10.2507 13.9106 10.3554 13.8771C10.46 13.8379 10.5509 13.7849 10.6281 13.7179C10.7052 13.6508 10.7658 13.5726 10.8099 13.4832C10.8595 13.3883 10.8843 13.2821 10.8843 13.1647C10.8843 12.9189 10.7934 12.7263 10.6116 12.5866C10.4353 12.4469 10.1901 12.3771 9.87601 12.3771H9.38843V11.3798H9.83475C9.94485 11.3798 10.0524 11.3659 10.157 11.338C10.2617 11.31 10.3526 11.2682 10.4298 11.2123C10.5124 11.1509 10.5758 11.0754 10.6198 10.986C10.6694 10.891 10.6942 10.7821 10.6942 10.6592C10.6942 10.4692 10.6281 10.3156 10.4958 10.1983C10.3636 10.0754 10.1845 10.0139 9.9587 10.0139C9.71625 10.0139 9.5289 10.081 9.39674 10.215C9.26993 10.3435 9.18179 10.4888 9.13223 10.6509L8.14047 10.2402C8.19012 10.1005 8.26451 9.95812 8.36363 9.81288C8.46284 9.66198 8.58679 9.52793 8.73556 9.41062C8.88978 9.28767 9.06892 9.18993 9.2727 9.11731C9.47657 9.03914 9.71071 9 9.97522 9C10.2452 9 10.4904 9.03914 10.7107 9.11731C10.9366 9.19548 11.1294 9.30442 11.2893 9.44411C11.449 9.57816 11.573 9.74025 11.6611 9.93018C11.7492 10.1145 11.7934 10.3156 11.7934 10.5335C11.7934 10.7011 11.7713 10.8519 11.7273 10.986C11.6887 11.1201 11.6364 11.2402 11.5702 11.3463C11.5041 11.4525 11.427 11.5446 11.3388 11.6229C11.2562 11.6955 11.1708 11.7541 11.0826 11.7988V11.8659C11.3471 11.972 11.5648 12.1425 11.7355 12.3771C11.9119 12.6117 12 12.9078 12 13.2653C12 13.5168 11.9531 13.7486 11.8594 13.9609C11.7659 14.1676 11.6308 14.3491 11.4546 14.5056C11.2837 14.662 11.0771 14.7821 10.8347 14.8659C10.5923 14.9553 10.3223 15 10.0248 15Z"
                fill="#4285F4"
            />
            <path
                d="M14.1266 15V10.3508L13.32 10.7982L13 9.82461L14.34 9H15V15H14.1266Z"
                fill="#4285F4"
            />
        </svg>
    );
};

export default Google;
